module.exports = __webpack_public_path__ + "img/tool2.da43ad30.png";